// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Phone } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconPhone(props: any) {
    return <IconBase icon={Phone} {...props} />
  }

  export default IconPhone
  